import { getUiLang, localeFor, t } from './i18n';

export const WORDS_PER_MINUTE = 180;
export const DEFAULT_ITEM_WORDS = 400;

export function storyTime(it: { published_at: string | null; first_seen_at: string }): number {
  return new Date(it.published_at ?? it.first_seen_at).getTime();
}

export function timeAgo(iso: string | null | undefined): string {
  if (!iso) return '';
  const diff = Math.max(0, Date.now() - new Date(iso).getTime());
  const min = Math.floor(diff / 60000);
  if (min < 1) return t('time_now');
  if (min < 60) return t('time_min', { n: min });
  const h = Math.floor(min / 60);
  if (h < 24) return t('time_hour', { n: h });
  const d = Math.floor(h / 24);
  if (d < 14) return t('time_day', { n: d });
  return new Date(iso).toLocaleDateString(localeFor(getUiLang()), { day: 'numeric', month: 'short' });
}

export function readMinutes(words: number | null | undefined): number {
  return Math.max(1, Math.round((words || DEFAULT_ITEM_WORDS) / WORDS_PER_MINUTE));
}

export function longDate(d = new Date()): string {
  return d.toLocaleDateString(localeFor(getUiLang()), { weekday: 'long', day: 'numeric', month: 'long' });
}

export function greeting(d = new Date()): string {
  const h = d.getHours();
  if (h < 5) return t('greet_night');
  if (h < 12) return t('greet_morning');
  if (h < 18) return t('greet_day');
  if (h < 22) return t('greet_evening');
  return t('greet_night');
}

export function hostOf(url: string | null | undefined): string {
  if (!url) return '';
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

export function faviconFor(url: string | null | undefined): string | null {
  const host = hostOf(url);
  return host ? `https://www.google.com/s2/favicons?domain=${host}&sz=64` : null;
}

export function compactNumber(n: number | null | undefined): string {
  if (n == null) return '';
  return new Intl.NumberFormat(localeFor(getUiLang()), { notation: 'compact', maximumFractionDigits: 1 }).format(n);
}

export function formatPrice(n: number | null | undefined, digits?: number): string {
  if (n == null || !Number.isFinite(n)) return '—';
  const d = digits ?? (Math.abs(n) >= 1000 ? 0 : Math.abs(n) >= 1 ? 2 : 4);
  return new Intl.NumberFormat(localeFor(getUiLang()), { minimumFractionDigits: d, maximumFractionDigits: d }).format(n);
}

export function formatPct(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '—';
  const s = new Intl.NumberFormat(localeFor(getUiLang()), { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(n));
  return `${n > 0 ? '+' : n < 0 ? '−' : ''}${s}%`;
}

/** Kartın gövdesini paragraflara ayırır. */
export function paragraphs(body: string | null | undefined): string[] {
  return (body ?? '').split(/\n{2,}|\r\n\r\n/).map((p) => p.trim()).filter(Boolean);
}

export const IOS_URL = 'https://apps.apple.com/app/id6786414867';
export const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.horusstudios.careerdaily';
export const PRIVACY_URL = '/legal/privacy';
export const TERMS_URL = '/legal/terms';
export const REFUND_URL = '/legal/refund';

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);
export const MOD = isMac ? '⌘' : 'Ctrl';
